






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

const HINT_DURATION = 1000;

@Component
export default class ScrollTrap extends Vue {
  @Prop(Boolean) isMapFullscreen: false;

  trapDisabled = false;
  overlayTimer = 0;

  /* If map is in fullscreen mode, we completely disable the scrolltrap feature */
  @Watch('isMapFullscreen')
  handleScrollIfFullscreen (val: boolean) {
    if (val) {
      this.resetOverlay(true);
    } else {
      this.resetOverlay(false);
    }
  }

  /*
    The overlay will be displayed if user tries to scroll inside the container,
    and if the container hasn't been clicked once, to simulate 'focus' inside.
  */
  showOverlay (e: Event): void {
    if (process.client) {
      if (this.trapDisabled) return;
      e.stopPropagation();

      window.clearTimeout(this.overlayTimer);
      this.overlayTimer = window.setTimeout(() => {
        this.overlayTimer = 0;
      }, HINT_DURATION);
    }
  }

  /*
    The overlay will be reset when user clicks in the scroll trap after trying
    to scroll, which will be consider as "focusing inside the component to be
    able to use it"
  */
  resetOverlay (trapDisabled: boolean): void {
    if (process.client) {
      // if map is still fullscreen but mouse left, we don't want to disable scrolltrap
      if (this.isMapFullscreen && !trapDisabled) {
        return;
      }
      window.clearTimeout(this.overlayTimer);
      this.overlayTimer = 0;
      this.trapDisabled = trapDisabled;
    }
  }
}
